module.exports = __webpack_public_path__ + "static/media/rug3.303238b4.jpeg";